import React from 'react';
import { Circle, Popup } from 'react-leaflet';

// 1. Adicionada a prop 'color' na assinatura do componente:
const PlotStudentsLocation = ({ students, course, color }) => {
  return (
    <div className="PlotStudentsLocation">
      {/* 2. Removido 'color' dos parâmetros do .map */}
      {students.map((student, index) => {
        if (student.curso !== course && course !== 'all') {
          return null;
        }

        // Fator aleatório leve para desagrupar alunos com mesmo endereço exacto
        const factorLongitude = (Math.random() * 0.01) % 0.005;
        const factorLatitude = (Math.random() * 0.01) % 0.005;

        const longitude = student.lng + factorLongitude;
        const latitude = student.lat + factorLatitude;

        return (
          <Circle
            key={index}
            center={{ lat: latitude, lng: longitude }}
            fillColor={color || '#028436'}   /* Cor de preenchimento dinâmica */
            color={color || '#015222'}       /* Cor da borda dinâmica */
            weight={0.5}
            fillOpacity={0.35}       /* Transparência ideal para densidade */
            radius={80}              /* Raio em metros no Leaflet Circle */
          >
            <Popup>
              <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '12px' }}>
                <strong style={{ color: color || '#028436' }}>{student.curso}</strong><br />
                <span>Bairro: {student.bairro}</span><br />
                <span>Cidade: {student.cidade} - {student.estado}</span><br />
                <small style={{ color: '#666' }}>Situação: {student.situacao}</small>
              </div>
            </Popup>
          </Circle>
        );
      })}
    </div>
  );
};

export default PlotStudentsLocation;